import React, { Component } from "react";

import { CButton, CCardBody, CCard, CCardHeader, CLabel } from "@coreui/react";
import { connect } from "react-redux";
import SortableTree from "react-sortable-tree";
import {
  InputGroupAddon,
  InputGroupText,
  FormGroup,
  InputGroup,
  Input
} from "reactstrap";
import { bindActionCreators } from "redux";

import { logout, getMenuItens } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

import "react-sortable-tree/style.css";
import "./styles.css";

class RoleCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menu: [],
      loading: true,
      // loadingInternal: false,
      // newNode: {},
      // newItens: [],
      // modal: false,
      // called: {},
      name: "",
      type: "",
      edit: false
    };

    this.changeName = this.changeName.bind(this);
    this.create = this.create.bind(this);
    this.update = this.update.bind(this);
    this.getInfos = this.getInfos.bind(this);
    this.selectChildrens = this.selectChildrens.bind(this);
    this.insertBtn = this.insertBtn.bind(this);
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    const { id } = this.props.match.params;

    if (id) {
      this.setState({ edit: true });

      axios
        .get(`${URL.api}access/role/listRoleMenuGroup/${id}/0`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          this.setState({ userhave: resp.data.data.menu });

          axios
            .get(`${URL.api}access/role/singleView/${id}`, {
              headers: { authorization: `Bearer ${this.props.user.token}` }
            })
            .then(resp => {
              this.setState({
                name: resp.data.data.name,
                type: resp.data.data.type
              });
              this.getInfos();
            });
        });
    } else {
      this.getInfos();
    }
  }

  getInfos() {
    axios
      .get(`${URL.api}configuration/menu/listMenu`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        let { menu } = resp.data.data;
        let components = resp.data.data.routes;

        menu.forEach((primary, idp) => {
          menu[idp].title = primary.name;
          menu[idp].expanded = true;
          menu[idp].selected = false;
          if (primary.children) {
            primary.children.forEach((secondary, ids) => {
              menu[idp].children[ids].title = secondary.name;
              menu[idp].children[ids].expanded = true;
              menu[idp].children[ids].selected = false;
              if (secondary.children) {
                secondary.children.forEach((third, idt) => {
                  menu[idp].children[ids].children[idt].title = third.name;
                  menu[idp].children[ids].children[idt].expanded = true;
                  menu[idp].children[ids].children[idt].selected = false;
                });
              }
            });
          }
        });

        components.forEach((component, idc) => {
          components[idc].value = component.id;
        });

        let menuFather = {
          title: "Menu",
          id: 0,
          children: menu,
          expanded: true,
          selected: true
        };

        this.setState({
          menu: [menuFather],
          // components,
          loading: false
        });

        if (this.props.match.params.id) {
          this.setState({ loading: true });

          let { menu } = this.state;
          let have = this.state.userhave;

          menu.forEach((elem, idMenu) => {
            menu[idMenu].selected = true;
            if (elem.children) {
              elem.children.forEach((primary, idp) => {
                have.forEach((n1, idn1) => {
                  if (primary.id === n1.id) {
                    menu[idMenu].children[idp].selected = true;
                  }
                });
                if (primary.children) {
                  primary.children.forEach((secondary, ids) => {
                    have.forEach(n1 => {
                      if (n1.children) {
                        n1.children.forEach(n2 => {
                          if (secondary.id === n2.id) {
                            menu[idMenu].children[idp].children[
                              ids
                            ].selected = true;
                          }
                        });
                      }
                    });
                    if (secondary.children) {
                      secondary.children.forEach((third, idt) => {
                        have.forEach(n1 => {
                          if (n1.children) {
                            n1.children.forEach(n2 => {
                              if (n2.children) {
                                let n3Controller = false;
                                n2.children.forEach(n3 => {
                                  if (third.id === n3.id) {
                                    menu[idMenu].children[idp].children[
                                      ids
                                    ].children[idt].selected = true;
                                    n3Controller = true;
                                  }
                                });
                                if (!n3Controller) {
                                  n2.children.forEach(n3 => {
                                    menu[idMenu].children[idp].children[
                                      ids
                                    ].children[idt].selected = true;
                                  });
                                }
                              }
                            });
                          }
                        });
                      });
                    }
                  });
                }
              });
            }
          });

          this.setState({
            menu,
            loading: false
          });
        }
      });
  }

  selectChildrens(elem) {
    let { menu } = this.state;
    let deep = elem.path.length;
    this.setState(
      () => ({
        loading: true
      }),
      () => {
        if (deep === 1) {
          menu.forEach((primary, idp) => {
            menu[idp].selected = !menu[idp].selected;
            if (primary.children) {
              primary.children.forEach((secondary, ids) => {
                menu[idp].children[ids].selected =
                  !menu[idp].children[ids].selected;
                if (secondary.children) {
                  secondary.children.forEach((third, idt) => {
                    menu[idp].children[ids].children[idt].selected =
                      !menu[idp].children[ids].children[idt].selected;
                    if (third.children) {
                      third.children.forEach((fourth, idf) => {
                        menu[idp].children[ids].children[idt].children[
                          idf
                        ].selected =
                          !menu[idp].children[ids].children[idt].children[idf]
                            .selected;
                      });
                    }
                  });
                }
              });
            }
          });
        }
        if (deep === 2) {
          menu.forEach((primary, idp) => {
            menu[idp].selected = true;
            if (primary.children) {
              primary.children.forEach((secondary, ids) => {
                if (elem.node.id === secondary.id) {
                  menu[idp].children[ids].selected =
                    !menu[idp].children[ids].selected;
                  if (menu[idp].children[ids].auto !== true) {
                    if (secondary.children) {
                      secondary.children.forEach((third, idt) => {
                        menu[idp].children[ids].children[idt].selected =
                          !menu[idp].children[ids].children[idt].selected;
                        if (third.children) {
                          third.children.forEach((fourth, idf) => {
                            menu[idp].children[ids].children[idt].children[
                              idf
                            ].selected =
                              !menu[idp].children[ids].children[idt].children[
                                idf
                              ].selected;
                          });
                        }
                      });
                    }
                  }
                  menu[idp].children[ids].auto = false;
                }
              });
            }
          });
        }
        if (deep === 3) {
          menu.forEach((primary, idp) => {
            if (primary.children) {
              primary.children.forEach((secondary, ids) => {
                if (elem.parentNode.id === secondary.id) {
                  menu[idp].children[ids].selected = true;
                  menu[idp].children[ids].auto = true;
                  if (secondary.children) {
                    secondary.children.forEach((third, idt) => {
                      if (elem.node.id === third.id) {
                        menu[idp].children[ids].children[idt].selected =
                          !menu[idp].children[ids].children[idt].selected;
                        if (
                          menu[idp].children[ids].children[idt].auto !== true
                        ) {
                          if (third.children) {
                            third.children.forEach((fourth, idf) => {
                              menu[idp].children[ids].children[idt].children[
                                idf
                              ].selected =
                                !menu[idp].children[ids].children[idt].children[
                                  idf
                                ].selected;
                            });
                          }
                        }
                        menu[idp].children[ids].children[idt].auto = false;
                      }
                    });
                  }
                }
              });
            }
          });
        }
        if (deep === 4) {
          menu.forEach((primary, idp) => {
            if (primary.children) {
              primary.children.forEach((secondary, ids) => {
                if (secondary.children) {
                  secondary.children.forEach((third, idt) => {
                    if (elem.parentNode.id === third.id) {
                      menu[idp].children[ids].selected = true;
                      menu[idp].children[ids].auto = true;
                      menu[idp].children[ids].children[idt].selected = true;
                      menu[idp].children[ids].children[idt].auto = true;
                      if (third.children) {
                        third.children.forEach((fourth, idf) => {
                          if (elem.node.id === fourth.id) {
                            menu[idp].children[ids].children[idt].children[
                              idf
                            ].selected =
                              !menu[idp].children[ids].children[idt].children[
                                idf
                              ].selected;
                          }
                        });
                      }
                    }
                  });
                }
              });
            }
          });
        }
        this.setState(
          () => ({
            menu
          }),
          () => {
            this.setState(() => ({
              loading: false
            }));
          }
        );
      }
    );
  }

  insertBtn(rowInfo) {
    if (rowInfo.path.length === 1) {
      return {
        buttons: [
          <input
            type="checkbox"
            disabled
            defaultChecked={rowInfo.node.selected}
          ></input>
        ]
      };
    }
    if (rowInfo.path.length !== 4) {
      return {
        buttons: [
          <input
            type="checkbox"
            onClick={() => this.selectChildrens(rowInfo)}
            defaultChecked={rowInfo.node.selected}
          ></input>
        ]
      };
    }
    return {
      buttons: [
        <input
          type="checkbox"
          onClick={() => this.selectChildrens(rowInfo)}
          defaultChecked={rowInfo.node.selected}
        ></input>
      ]
    };
  }

  create() {
    let menus = this.state.menu;
    let menuEnvio = [];
    menus.forEach((primary, idp) => {
      if (primary.children) {
        primary.children.forEach((secondary, ids) => {
          if (secondary.selected) {
            menuEnvio.push(secondary);
          }
          if (secondary.children) {
            secondary.children.forEach((third, idt) => {
              if (third.selected) {
                menuEnvio.push(third);
              }
              if (third.children) {
                third.children.forEach((fourth, idf) => {
                  if (fourth.selected) {
                    menuEnvio.push(fourth);
                  }
                });
              }
            });
          }
        });
      }
    });
    let dataObj = {
      name: this.state.name,
      type: this.state.type,
      group_id: null,
      menu: menuEnvio,
      loggedUser: this.props.user.user.id
    };
    this.setState(
      {
        loading: true
      },
      () => {
        axios
          .post(`${URL.api}role/insert`, dataObj, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          })
          .then(resp => {
            if (resp.data.success) {
              this.props.history.push("/role/list");
            }
          });
      }
    );
  }

  update() {
    const { id } = this.props.match.params;
    let menus = this.state.menu;
    let menuEnvio = [];
    menus.forEach((primary, idp) => {
      if (primary.children) {
        primary.children.forEach((secondary, ids) => {
          if (secondary.selected) {
            menuEnvio.push(secondary);
          }
          if (secondary.children) {
            secondary.children.forEach((third, idt) => {
              if (third.selected) {
                menuEnvio.push(third);
              }
              if (third.children) {
                third.children.forEach((fourth, idf) => {
                  if (fourth.selected) {
                    menuEnvio.push(fourth);
                  }
                });
              }
            });
          }
        });
      }
    });
    let dataObj = {
      id,
      name: this.state.name,
      type: this.state.type,
      group_id: null,
      menu: menuEnvio,
      loggedUser: this.props.user.user.id
    };
    this.setState(
      {
        loading: true
      },
      () => {
        axios
          .post(`${URL.api}role/update/${id}`, dataObj, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          })
          .then(resp => {
            if (resp.data.success) {
              this.props.history.push("/role/list");
            }
          });
      }
    );
  }

  changeName(event) {
    this.setState({ name: event.target.value });
  }

  changeType(event) {
    this.setState({ type: event.target.value });
  }

  render() {
    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/role/list", to: "/role/list" }]}
        />
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <CCard>
            <CCardHeader className="d-flex align-items-center">
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <h4 className="card-title mb-1">
                  {this.state.edit ? "Editar Perfil" : "Criar Perfil"}
                </h4>
                <div className="small text-muted">
                  {this.state.edit
                    ? "Edite o perfil selecionado"
                    : "Crie um novo perfil"}
                </div>
              </div>
              <CButton
                color="primary"
                onClick={() =>
                  this.state.edit ? this.update() : this.create()
                }
                disabled={this.state.fase !== this.state.fases}
              >
                <i className="fa fa-cloud-upload mr-2"></i>Salvar
              </CButton>
            </CCardHeader>
            <CCardBody>
              <FormGroup>
                <CLabel>Nome</CLabel>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="fa fa-user"></i>
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type="text"
                    placeholder="Nome do perfil"
                    onChange={this.changeName}
                    value={this.state.name}
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <CLabel>Tipo</CLabel>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="fa fa-adjust"></i>
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type="text"
                    placeholder="Tipo"
                    onChange={this.changeType}
                    value={this.state.type}
                  />
                </InputGroup>
              </FormGroup>
              <CLabel>Menus</CLabel>
              <div className="menuTreeArea">
                <SortableTree
                  treeData={this.state.menu}
                  toggleExpandedForAll
                  onChange={treeData => this.setState({ menu: treeData })}
                  generateNodeProps={this.insertBtn}
                  canDrag={() => false}
                  canDrop={() => false}
                  isVirtualized={false}
                />
              </div>
            </CCardBody>
          </CCard>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      getMenuItens,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(RoleCreate);
